import Vue from 'vue'
// 公用方法文件

let methods = {
  // 平滑滚动到页面顶部
  $smoothScrollToTop: () => {
    Vue.nextTick(() => {
      let firstChildEle = window.document.children[0]
      firstChildEle && firstChildEle.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })
    })
  }
}

export default function globalMethod (app) {
  Object.keys(methods).forEach(key => {
    app.prototype[key] = methods[key]
  })
}



// WEBPACK FOOTER //
// ./src/global/method.js